export default "__VITE_ASSET__BsCeVfg9__"